import React from "react";
import PropTypes from "prop-types";

const ErrorRow = ({ columns, errors }) => {
  const hasErrors = Object.keys(errors).length > 0;

  if (!hasErrors) return null;

  return (
    <tr className="error-row">
      {columns.map((column) => (
        <td key={column.accessor}>
          {errors[column.accessor] && (
            <div className="error-text">{errors[column.accessor]}</div>
          )}
        </td>
      ))}
    </tr>
  );
};

ErrorRow.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string.isRequired,
    })
  ).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default ErrorRow;
